import type {
    DocumentWithAuthor,
    DocumentWithPublicity,
    DocumentWithSoftDelete,
    DocumentWithTimestamps,
    Timestamp
} from './firebase.ts'
import type { OrgId, UserId } from './ids.ts'
import type { OrgMeta } from './Org.ts'
import type { RelatedItems } from './RelatedItems.ts'

export type SkillId = string

export enum SkillType {
    kurz = 'kurz',
    event = 'event',
    workgroup = 'workgroup',
    studyOpportunity = 'studyOpportunity'
}

export interface Lesson {
    id?: string
    title?: string
    desc?: string
    content?: string
    publishedDate?: string
    videoUrl?: string
    durationMinutes?: number
    exercise?: string
}

export type CourseLevel = 'beginner' | 'intermediate' | 'advanced'

export type Skill = DocumentWithTimestamps &
    DocumentWithAuthor &
    DocumentWithSoftDelete &
    DocumentWithPublicity & {
        id: SkillId
        orgId: OrgId | null
        orgMeta: OrgMeta
        slug?: string
        title: string
        type: string
        desc: string
        author?: string
        image: string
        contentURL: string
        contentURLType: string
        recordingURL: string
        recordingURLType: string
        liveURL?: string
        liveDate?: string
        slido?: string
        category: string
        authorBio?: string
        content: string
        who: string[]
        topics: string[]
        format: string
        startDate: Timestamp | number // in Search is set to "-1" when type is kurz
        time: string
        placeCategory: string
        placeAddress: string
        placeOnline: string
        priceCategory?: string
        price: number | null
        capacityCategory: string
        capacity: number | null
        lessons: Lesson[]
        learningOutcomes?: string[]
        courseLevel?: CourseLevel
        coursePrerequisites?: string
        relatedItems?: RelatedItems
        memberIds?: UserId[]
        studyLink?: string
    }

export type SkillFormData = Omit<Partial<Skill>, 'createdAt' | 'updatedAt' | 'deletedAt'>

export type SkillOrgPreview = Pick<OrgMeta, 'id' | 'slug' | 'title' | 'type'> & {
    memberIds: UserId[]
}
